import { z } from 'zod';

const stepSchema = z.object({
  icon: z.string().min(1, 'Step icon is required'),
  title: z.string().min(1, 'Step title is required'),
  description: z.string(),
});

const qualifiedSchema = z.object({
  alert: z.string(),
  title: z.string().min(1, 'Qualified title is required'),
  help: z.string(),
  steps: z.array(stepSchema),
});

const resultSchema = z.object({
  alert: z.string(),
  title: z.string().min(1, 'Title is required'),
  help: z.string(),
  message: z.string().min(1, 'Message is required'),
});

const messagesLocaleSchema = z.object({
  qualified: qualifiedSchema,
  not_qualified: resultSchema,
  duplicated: resultSchema,
});

/**
 * Spanish is a secondary locale: every field accepts an empty string (and steps an empty
 * array) so a message set can be saved with English copy alone. The renderer falls back to
 * English when a Spanish field is blank.
 */
const optionalStepSchema = z.object({
  icon: z.string(),
  title: z.string(),
  description: z.string(),
});

const optionalQualifiedSchema = z.object({
  alert: z.string(),
  title: z.string(),
  help: z.string(),
  steps: z.array(optionalStepSchema),
});

const optionalResultSchema = z.object({
  alert: z.string(),
  title: z.string(),
  help: z.string(),
  message: z.string(),
});

const optionalMessagesLocaleSchema = z.object({
  qualified: optionalQualifiedSchema,
  not_qualified: optionalResultSchema,
  duplicated: optionalResultSchema,
});

export const formMessageSchema = z.object({
  id: z.number().int().positive().optional(),
  is_default: z.boolean(),
  messages: z.object({
    name: z.string().min(1, 'Name is required').max(255),
    i18n: z.object({
      en: messagesLocaleSchema,
      es: optionalMessagesLocaleSchema,
    }),
  }),
});

export type FormMessageInput = z.infer<typeof formMessageSchema>;
export type FormMessageStepInput = z.infer<typeof stepSchema>;
